export default __webpack_public_path__ + "static/media/green-dot.62fd343b.svg";